export type PwaPlatform = "ios" | "android" | "desktop" | "other";

function isIOSDevice(ua: string): boolean {
  return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

export function detectPlatform(): PwaPlatform {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent;
  if (isIOSDevice(ua)) return "ios";
  if (/Android/.test(ua)) return "android";
  if (/Mobi/.test(ua)) return "other";
  return "desktop";
}

export function detectStandalone(): boolean {
  if (typeof window === "undefined") return false;
  const iosStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  return window.matchMedia("(display-mode: standalone)").matches || iosStandalone;
}

/**
 * true si el navegador es Safari en iOS/iPadOS. En iOS, Chrome/Firefox/Edge corren sobre WebKit
 * pero no pueden agregar a pantalla de inicio: solo Safari lo permite.
 */
export function detectIsIosSafari(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  if (!isIOSDevice(ua)) return false;
  return !/CriOS|FxiOS|EdgiOS|OPiOS|mercury/i.test(ua);
}
